"use strict";
/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8762%3A53981&t=a8d20mmtori6OOti-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonTokenValue = exports.commonTokens = void 0;
const colors_1 = require("../colors");
const shared = {
    border: (0, colors_1.getColorValue)('grey.300'),
    disabled: (0, colors_1.getColorValue)('grey.500'),
    error: (0, colors_1.getColorValue)('red.600'),
    light: (0, colors_1.getColorValue)('grey.600'),
    primary: (0, colors_1.getColorValue)('grey.800'),
    secondary: (0, colors_1.getColorValue)('grey.700'),
    success: (0, colors_1.getColorValue)('green.600'),
};
const texts = {
    'text-discreet': (0, colors_1.getColorValue)('grey.600'),
    'text-label': (0, colors_1.getColorValue)('grey.700'),
    'text-light': (0, colors_1.getColorValue)('grey.600'),
    'text-placeholder': (0, colors_1.getColorValue)('grey.600'),
    'text-primary': (0, colors_1.getColorValue)('grey.800'),
    'text-secondary': (0, colors_1.getColorValue)('grey.700'),
    'text-title': (0, colors_1.getColorValue)('grey.800'),
};
exports.commonTokens = {
    ...shared,
    ...texts,
};
const getCommonTokenValue = (token) => {
    return exports.commonTokens[token];
};
exports.getCommonTokenValue = getCommonTokenValue;
